import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { NavUrls } from './enums/nav-urls';

const routes: Routes = [
  {
    path: '',
    redirectTo: NavUrls.LOGIN,
    pathMatch: 'full',
  },
  // {
  //   path: 'folder/:id',
  //   loadChildren: () => import('./pages/folder/folder.module').then(m => m.FolderPageModule)
  // },
  {
    path: NavUrls.LOGIN,
    loadChildren: () => import('./pages/login/login.module').then((m) => m.LoginPageModule),
    data: { hideSplitPane: true },
  },
  {
    path: NavUrls.REGISTER,
    loadChildren: () => import('./pages/register/register.module').then((m) => m.RegisterModule),
    data: { hideSplitPane: true },
  },
  {
    path: NavUrls.ACCOUNT_CONFIRM,
    loadChildren: () => import('./pages/account-confirm/account-confirm.module').then((m) => m.AccountConfirmModule),
    data: { hideSplitPane: true },
  },
  {
    path: NavUrls.ACCOUNT_CONFIRM + '/:usernameEmail',
    loadChildren: () => import('./pages/account-confirm/account-confirm.module').then((m) => m.AccountConfirmModule),
    data: { hideSplitPane: true },
  },
  {
    path: NavUrls.FIELDS,
    loadChildren: () => import('./pages/fields/fields.module').then((m) => m.FieldsPageModule),
  },
  {
    path: NavUrls.LOST_PASSWORD,
    loadChildren: () => import('./pages/lost-password/lost-password.module').then((m) => m.LostPasswordModule),
    data: { hideSplitPane: true },
  },
  {
    path: NavUrls.DASHBOARD,
    loadChildren: () => import('./pages/dashboard/dashboard.module').then((m) => m.DashboardPageModule),
  },
  {
    path: NavUrls.IMPLEMENTS,
    loadChildren: () => import('./pages/implements/implements.module').then((m) => m.ImplementsPageModule),
  },
  {
    path: NavUrls.JOBS,
    loadChildren: () => import('./pages/jobs/jobs.module').then((m) => m.JobsPageModule),
  },
  {
    path: NavUrls.MACHINES,
    loadChildren: () => import('./pages/machines/machines.module').then((m) => m.MachinesPageModule),
  },
  {
    path: NavUrls.LOCATIONS,
    loadChildren: () => import('./pages/locations/locations.module').then((m) => m.LocationsPageModule),
  },
  {
    path: NavUrls.EMPLOYEES,
    loadChildren: () => import('./pages/employees/employees.module').then((m) => m.EmployeesPageModule),
  },
  {
    path: NavUrls.CUSTOMERS,
    loadChildren: () => import('./pages/customers/customers.module').then((m) => m.CustomersPageModule),
  },
  {
    path: NavUrls.DASHBOARD_MAP,
    loadChildren: () => import('./pages/map/map.module').then((m) => m.MapPageModule),
  },
  {
    path: NavUrls.DASHBOARD_DASH,
    loadChildren: () => import('./pages/dash/dash.module').then((m) => m.DashPageModule),
  },
  {
    path: NavUrls.DASHBOARD_WIDGETS,
    loadChildren: () => import('./pages/status/status.module').then((m) => m.StatusPageModule),
  },

  // {
  //   path: NavUrls.JOBDETAILS,
  //   loadChildren: () => import('./pages/job-details/job-details.module').then( m => m.JobDetailsPageModule)
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, paramsInheritanceStrategy: 'always' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
